import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useLayoutEffect, useState } from 'react';
import styles from './VisualModal.module.scss';
const VisualModal = t0 => {
  const $ = _c(13);
  const {
    ref,
    open,
    position,
    children
  } = t0;
  const [openWithoutShiftm, setOpenWithoutShiftm] = useState(false);
  let t1;
  if ($[0] !== position.left || $[1] !== position.top) {
    t1 = {
      left: position.left,
      top: position.top
    };
    $[0] = position.left;
    $[1] = position.top;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dynamicModalStyles = t1;
  const t2 = openWithoutShiftm ? styles.open : styles.hide;
  let t3;
  if ($[3] !== t2) {
    t3 = classNames(styles.root, t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const modalClassName = t3;
  let t4;
  let t5;
  if ($[5] !== open) {
    t4 = () => {
      window.requestAnimationFrame(() => setOpenWithoutShiftm(open));
    };
    t5 = [open];
    $[5] = open;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useLayoutEffect(t4, t5);
  let t6;
  if ($[8] !== children || $[9] !== dynamicModalStyles || $[10] !== modalClassName || $[11] !== ref) {
    t6 = <div ref={ref} className={modalClassName} style={dynamicModalStyles}>{children}</div>;
    $[8] = children;
    $[9] = dynamicModalStyles;
    $[10] = modalClassName;
    $[11] = ref;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default VisualModal;